var exports = {
  "rf": "xa15a2ab7--cce4c9--body",
  "XO": "xa15a2ab7--cce4c9--question_block",
  "o1": "xa15a2ab7--cce4c9--actions",
  "gP": "xa15a2ab7--cce4c9--action_button",
};

module.exports = exports;
